'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { PageNavigation } from '@/components/client';
import { FilterSection } from './_components/FilterSection';
import { OrderList, OrderListErrorFallback } from './_components/OrderList';
import type { PeriodOption } from './constants';
import { PERIOD_OPTIONS } from './constants';
import type { OrderStatusValue } from './types';
const DEFAULT_PERIOD = PERIOD_OPTIONS[2]; // 1개월

const MyOrdersPage = () => {
  const $ = _c(13);
  const [orderStatus, setOrderStatus] = useState("");
  const [period, setPeriod] = useState(DEFAULT_PERIOD);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex flex-1 flex-col pb-80", "mobile-tablet:pb-20");
    t1 = <PageNavigation title={"\uC8FC\uBB38 \uB0B4\uC5ED"} isNotUsedHomeButton={true} />;
    t2 = <h2 className="pb-14 font-700 text-Gray-900 typo-h5 mobile-tablet:sr-only mobile-tablet:hidden">주문 내역</h2>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== orderStatus || $[4] !== period) {
    t3 = <FilterSection orderStatus={orderStatus} period={period} onStatusChange={setOrderStatus} onPeriodChange={setPeriod} />;
    $[3] = orderStatus;
    $[4] = period;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <OrderListErrorFallback />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== orderStatus || $[8] !== period) {
    t5 = <ErrorBoundary fallback={t4}><OrderList orderStatus={orderStatus} period={period} /></ErrorBoundary>;
    $[7] = orderStatus;
    $[8] = period;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className={t0}>{t1}{t2}{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default MyOrdersPage;